import { TResource } from 'Models/Resource/@types';
import { parseResource, parseResourceFormData } from 'Models/Resource/resourceParsers';
import AxiosUtils, { request } from 'Resources/AxiosUtils';
import { JSONType } from 'Typings/Global';

class CollectModel {
  static getAllCollects = async (params?: Record<string, any>): Promise<JSONType[]> => {
    const res = await request<JSONType[]>({
      url: '/collects',
      method: 'GET',
      params,
    });
    return res.map(parseResource);
  };

  static getCollect = async (id: string, params?: Record<string, any>): Promise<TResource> => {
    const res = await request<JSONType>({
      url: `/resources/${id}/find/Collect`,
      method: 'GET',
      params,
    });
    return parseResource(res);
  };

  static updateCollect = async (data: Partial<TResource> & { id: string }): Promise<TResource> => {
    const res = await request({
      url: `/collects/${data.id}`,
      method: 'patch',
      data: { ...parseResourceFormData(data) },
    }).catch(AxiosUtils.throwError);
    if (!res) return Promise.reject();
    return { ...data, ...parseResource(res) } as TResource;
  };

  static deleteCollects = async (ids: string[]): Promise<JSONType> => {
    const res = await request<JSONType>({
      url: '/collects/trash',
      method: 'DELETE',
      data: { ids },
    });
    return res;
  };

  static togglePublishCollect = (id: string, publish: boolean): Promise<JSONType> =>
    request<JSONType>({
      url: `/collects/${id}/publish`,
      method: 'post',
      params: { publish },
    });
}

export default CollectModel;
